import React, { Component } from "react";
import { pad, addDecimalPoints } from "../shared/utils";

export default class FormatedCurrency extends Component {
	render() {
		const value = parseFloat(this.props.value || 0)
			.toFixed(2)
			.toString()
			.split(".");

		return (
			<span>
				{this.props.currency || "R$ "}
				{addDecimalPoints(value[0])},{pad(value[1])}
			</span>
		);
	}
}
